export interface INavigationRoute {
  name: string
  path?: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: '首页',
  },
  routes: [
    {
      name: 'dashboard',
      path: '/dashboard',
      displayName: '首页',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'proxy-orders',
      path: '/proxy/orders',
      displayName: '我的转换',
      meta: {
        icon: 'dns',
      },
    },
    {
      name: 'proxy-create',
      path: '/proxy/create',
      displayName: '制作转换',
      meta: {
        icon: 'add_circle',
      },
    },
    {
      name: 'notices',
      path: '/notices',
      displayName: '通知公告',
      meta: {
        icon: 'notifications',
      },
    },
    {
      name: 'account',
      path: '/account',
      displayName: '账号中心',
      meta: {
        icon: 'manage_accounts',
      },
    },
  ] as INavigationRoute[],
}
